"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var AuthService = /** @class */ (function () {
    function AuthService(httpClient, store) {
        this.httpClient = httpClient;
        this.store = store;
        this.authUrl = skynet_store_properties_api_1.getProperties(this.store).pipe(operators_1.map(function (properties) { return lodash_1.get(properties, 'auth-service-url'); }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, new skynet_store_utilities_1.StoreManagerError('Url for auth-service-url was not found')));
    }
    AuthService_1 = AuthService;
    AuthService.prototype.login = function (username, password, headers) {
        var _this = this;
        return this.authUrl.pipe(operators_1.switchMap(function (url) {
            return _this.httpClient.post(url + "/oauth/token?grant_type=password&username=" + username + "&password=" + password + "&scope", undefined, {
                headers: headers ? headers : AuthService_1.defaultHeaders,
            });
        }));
    };
    AuthService.defaultHeaders = {
        'Content-type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic Y2xpZW50OnNlY3JldA==',
    };
    AuthService = AuthService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            store_1.Store])
    ], AuthService);
    return AuthService;
    var AuthService_1;
}());
exports.AuthService = AuthService;
//# sourceMappingURL=auth.service.js.map